<p-table [value]="configPresorteos" styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="id">Configuración <p-sortIcon field="id"></p-sortIcon></th>
            <th >Estado</th>
            <th >Herramientas</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-config>
        <tr>
            <td class="text-center">Configuración {{config.id}}</td>
            <td class="text-center" *ngIf="config.status == 'enabled'" style="color:#1cf308">Activo</td>
            <td class="text-center" *ngIf="config.status == 'disabled'" style="color:#cf0e0e">Inactivo</td>
            <td class="text-center"><p-button icon="pi pi-pencil" (click)="goToEdit(config.id)"></p-button></td>
        </tr>
    </ng-template>
</p-table>
